const article = {
    slug: "rick-owens",
    category: "BRAND BUYBACK",
    listTitle: "Rick Owens買取",
    listDescription:
      "レザー、ジオバスケット、DRKSHDW、アウター、ブーツ、アーカイブ作品まで、Rick Owensの造形性と市場価値を見て査定する専用買取ページ。",
    seo: {
      title:
        "Rick Owens買取｜リックオウエンスのアーカイブ価値まで査定するEnclopedia",
      description:
        "Rick Owens（リックオウエンス）の買取ならEnclopediaへ。レザージャケット、ジオバスケット、ラモーンズ、DRKSHDW、コート、パンツ、ブーツ、スニーカー、アーカイブ作品まで、シーズン背景・造形性・希少性・市場価値を見て査定。LINE事前査定から全国対応の宅配買取へご案内します。",
      keyword:
        "Rick Owens 買取,リックオウエンス 買取,Rick Owens 高価買取,リックオウエンス 高価買取,Rick Owens 宅配買取,リックオウエンス 宅配買取,Rick Owens LINE査定,リックオウエンス 買取相場,Rick Owens アーカイブ 買取,リックオウエンス アーカイブ 買取,DRKSHDW 買取,ダークシャドウ 買取,Rick Owens レザー 買取,Rick Owens ジオバスケット 買取,Rick Owens ラモーンズ 買取,Rick Owens ブーツ 買取,Rick Owens スニーカー 買取,アーカイブ買取,enclopedia,アンクロペディア",
      canonicalPath: "/brand_buyback/rick-owens",
    },
    hero: {
      label: "RICK OWENS BUYBACK",
      number: "08 / BUYBACK",
      titleLines: [
        "Rick Owens買取。",
        "造形と空気感まで見て査定します。",
      ],
      body:
        "Enclopediaは、Rick Owensをブランド名や型番だけで一律に判断しません。\nレザー、ドレープ、ロングシルエット、サルエルパンツ、ブーツ、ジオバスケット、ラモーンズ、DRKSHDWまで、Rick Owensならではの造形性・シーズン背景・現在の需要を確認し、個々のアイテムにフォーカスして査定します。\nまずはLINEで無料の事前査定。納得いただけた方を、全国対応の宅配買取へご案内します。",
      primaryCtaLabel: "LINEで事前査定する",
      primaryCtaHref: "https://line.me/R/ti/p/@240yzqkh",
      secondaryCtaLabel: "宅配買取を申し込む",
      secondaryCtaHref:
        "https://www.enclopedia-official.com/kaitori/takuhai",
      keywords: [
        "rick owens buyback",
        "archive valuation",
        "gothic minimalism",
        "sculptural silhouette",
      ],
      visualLabel: "ARCHIVE VALUATION",
      visualTitle: [
        "黒い服としてではなく、",
        "輪郭を変える服として見る。",
      ],
      image: "media/archive_fashion/buyback8.png",
      imageAlt: "Rick Owens買取のメイン画像",
    },
    thesis: {
      text:
        "Rick Owensの価値は、ブランド名だけでなく、シルエット・素材・シーズン性・身体の見え方まで見て判断する。",
      keywords: ["silhouette", "leather", "archive rarity"],
    },
    intro: {
      label: "02 / OUR BUYBACK VIEW",
      titleLines: [
        "Rick Owensの価値は、",
        "“黒くてモード”だけでは測れない。",
      ],
      body:
        "Rick Owensは、退廃的なムード、彫刻的なシルエット、レザーやジャージーの重さ、身体のラインを変えるパターンで独自の世界を築いてきたブランドです。\n同じ黒い服でも、レザー、ドレープ、ロング丈、サルエル、ブーツ、スニーカー、DRKSHDWでは評価軸が異なります。\nEnclopediaでは、単に人気モデルかどうかではなく、その一着がRick Owensの中でどのような輪郭と価値を持つかまで確認して査定します。",
    },
    valuation: {
      label: "03 / WHAT WE VALUE",
      titleLines: [
        "Enclopediaが重視する、",
        "3つの査定視点。",
      ],
      items: [
        {
          number: "01",
          title: "シルエットと造形を見る",
          text:
            "ロング丈、ドレープ、サルエル、極端なボリューム、鋭い肩線など、Rick Owensらしい身体の見え方を確認します。",
        },
        {
          number: "02",
          title: "素材と経年の状態を見る",
          text:
            "レザー、ムートン、ジャージー、ナイロン、デニムなど、素材ごとの状態差や経年変化を踏まえて査定します。",
        },
        {
          number: "03",
          title: "定番需要と希少性を見る",
          text:
            "ジオバスケット、ラモーンズ、ブーツなどの定番需要に加え、流通量の少ないアーカイブやシーズン品も個別に判断します。",
        },
      ],
    },
    targetLines: {
      label: "04 / TARGET ITEMS",
      titleLines: [
        "Rick Owens全般を、",
        "幅広く査定します。",
      ],
      items: [
        {
          tag: "ITEM 01",
          title: "Rick Owens メインライン",
          text:
            "レザージャケット、コート、ニット、カットソー、パンツ、ドレス、ブーツなど、メインラインの世界観が強い品を査定します。",
        },
        {
          tag: "ITEM 02",
          title: "DRKSHDW / ダークシャドウ",
          text:
            "デニム、スウェット、フーディー、カットソー、ラモーンズなど、日常性とRick Owensらしさを併せ持つラインも対象です。",
        },
        {
          tag: "ITEM 03",
          title: "レザー・ムートン・アウター",
          text:
            "リックを象徴するレザー、ムートン、ロングコート、ボンバー、ダウン、ジャケット類を丁寧に確認します。",
        },
        {
          tag: "ITEM 04",
          title: "ジオバスケット・ラモーンズ",
          text:
            "Rick Owensを代表するスニーカー類。サイズ、状態、カラー、素材、ソール減り、箱や付属品の有無まで見ます。",
        },
        {
          tag: "ITEM 05",
          title: "ブーツ・サンダル・シューズ",
          text:
            "レースアップブーツ、サイドジップブーツ、キスブーツ、サンダルなど、足元で世界観を作るアイテムも査定対象です。",
        },
        {
          tag: "ITEM 06",
          title: "サルエル・カーゴ・パンツ類",
          text:
            "股上の深いパンツ、カーゴパンツ、ドロップクロッチ、ワイドシルエットなど、造形性のあるボトムスを見ます。",
        },
        {
          tag: "ITEM 07",
          title: "バッグ・アクセサリー",
          text:
            "バッグ、ベルト、ウォレット、ジュエリー、小物類も、アイテム内容と市場需要に応じて査定します。",
        },
        {
          tag: "ITEM 08",
          title: "過去シーズンのアーカイブ",
          text:
            "古いだけで高くなるわけではありませんが、現在も評価されるシーズン品や流通量の少ない作品はアーカイブ価値まで見ます。",
        },
      ],
    },
    highValueItems: {
      label: "05 / HIGH VALUE ITEMS",
      titleLines: [
        "高価買取につながりやすい、",
        "Rick Owensのアイテム。",
      ],
      intro:
        "査定額は状態や相場で変動しますが、Enclopediaでは特に以下のようなRick Owensを丁寧に確認します。",
      items: [
        {
          index: "01",
          title: "レザー・ムートン・構築的アウター",
          text:
            "Rick Owensの世界観が強く出るアウター類は、素材の状態、シルエット、年代、現在需要を踏まえて査定します。",
        },
        {
          index: "02",
          title: "ジオバスケット・ラモーンズ・人気スニーカー",
          text:
            "定番として需要が強いシューズ類は、サイズ、カラー、ソールの減り、付属品、状態によって評価が変わります。",
        },
        {
          index: "03",
          title: "ブーツ・キスブーツ・存在感のあるフットウェア",
          text:
            "Rick Owensらしい重さと造形が出るブーツ類は、コーディネートの核になるアイテムとして丁寧に確認します。",
        },
        {
          index: "04",
          title: "サルエルパンツ・カーゴパンツ・ロング丈トップス",
          text:
            "身体のバランスを変えるシルエットを持つアイテムは、Rick Owensの着用価値として査定に反映します。",
        },
        {
          index: "05",
          title: "DRKSHDWの人気モデル・状態良好品",
          text:
            "DRKSHDWは流通量が比較的多い一方、人気モデルや状態の良い品、需要の強いサイズは評価対象として確認します。",
        },
      ],
    },
    quote: {
      textLines: [
        "“黒い服”としてではなく、",
        "身体の輪郭を変える服として見る。",
      ],
    },
    assessmentDifference: {
      label: "06 / ASSESSMENT DIFFERENCE",
      titleLines: [
        "一般的な査定で、",
        "見落とされやすいRick Owensの価値。",
      ],
      intro:
        "Rick Owensは、同じ黒・同じ定番でも、素材、シルエット、年代、サイズ需要によって評価が大きく変わるブランドです。",
      items: [
        {
          index: "01",
          title: "黒い服を一括で見ない",
          text:
            "Rick Owensの黒は、素材の重さ、落ち感、身体との距離で印象が変わります。単なるカラーではなく、造形として確認します。",
        },
        {
          index: "02",
          title: "定番品を型番だけで終わらせない",
          text:
            "ジオバスケットやラモーンズも、素材、カラー、サイズ、状態、付属品、現在需要で評価が変わります。",
        },
        {
          index: "03",
          title: "着用価値とアーカイブ性をあわせて見る",
          text:
            "Enclopediaはアーカイブのレンタル・共有を行うため、次の着用者へ渡る価値があるかという視点も持って査定します。",
        },
      ],
    },
    flow: {
      label: "07 / BUYBACK FLOW",
      titleLines: [
        "LINE事前査定から、",
        "宅配買取へ。",
      ],
      items: [
        {
          step: "STEP 01",
          title: "LINEで事前査定",
          text:
            "写真と簡単な情報をお送りください。全体、ブランドタグ、品番タグ、素材表記、ダメージ箇所、シューズの場合はソール状態が分かる写真があると確認しやすくなります。",
        },
        {
          step: "STEP 02",
          title: "宅配買取を申込",
          text:
            "本査定をご希望の場合は申込フォームへ。宅配キットの要否もここで選択できます。",
        },
        {
          step: "STEP 03",
          title: "無料で発送",
          text:
            "送料は無料。レザーやブーツなど重量のあるアイテムも、ご自身の箱または選択制の宅配キットでお送りいただけます。",
        },
        {
          step: "STEP 04",
          title: "本査定・ご入金",
          text:
            "到着後に状態・真贋・市場性・アーカイブ価値を確認。金額にご納得いただければご指定口座へ入金します。",
        },
      ],
    },
    assurance: {
      label: "08 / SAFE BUYBACK",
      titleLines: [
        "相談しやすく、",
        "進めやすいRick Owens買取。",
      ],
      intro:
        "LINEで相談してから進められるため、レザー、ブーツ、アーカイブ品、相場が分かりにくいアイテムも、宅配買取へ進む前に確認できます。",
      items: [
        {
          title: "LINE事前査定あり",
          text:
            "まず相談してから進められるため、状態や市場性に不安がある品も事前に確認できます。",
        },
        {
          title: "送料は無料",
          text:
            "宅配買取の発送費用はEnclopediaが負担します。",
        },
        {
          title: "宅配キットは選択制",
          text:
            "必要な方には宅配キットをご用意。ご自身で梱包できる場合はそのまま発送可能です。",
        },
        {
          title: "キャンセル返送料は基本無料",
          text:
            "査定金額にご納得いただけない場合の返送も基本無料です。",
        },
      ],
      notice:
        "キャンセル返送料は基本無料です。ただし、お送りいただいた品がすべてコピー品、または真贋判定不可品のみだった場合は、返送料をご負担いただく場合があります。",
    },
    faq: {
      label: "09 / FAQ",
      titleLines: [
        "Rick Owens買取で、",
        "よくあるご質問。",
      ],
      items: [
        {
          question:
            "どのRick Owensアイテムを買取していますか？",
          answer:
            "レザージャケット、コート、ニット、カットソー、パンツ、ブーツ、スニーカー、バッグ、アクセサリー、DRKSHDWまで幅広くご相談いただけます。",
        },
        {
          question:
            "DRKSHDWも査定できますか？",
          answer:
            "はい。DRKSHDWのデニム、フーディー、カットソー、パンツ、ラモーンズなども査定対象です。状態や需要を確認して個別に判断します。",
        },
        {
          question:
            "ジオバスケットやラモーンズも買取対象ですか？",
          answer:
            "はい。Rick Owensを代表するスニーカーとして、サイズ、カラー、素材、ソールの減り、箱や付属品の有無まで確認します。",
        },
        {
          question:
            "レザーやブーツは高く売れますか？",
          answer:
            "状態・モデル・サイズ・年代・現在需要によって変わりますが、Rick Owensらしさが強いレザーやブーツは丁寧に評価します。",
        },
        {
          question:
            "古いRick Owensのアーカイブも査定できますか？",
          answer:
            "はい。年代だけで一律には判断せず、シーズン性、希少性、状態、現在の需要を踏まえて個別に査定します。",
        },
        {
          question:
            "Rick Owensの買取相場を先に知りたいです。",
          answer:
            "まずはLINEで写真をお送りください。モデル、品番、状態、サイズ、付属品、現在需要を確認し、宅配買取へ進む前に大まかな方向性をご案内します。",
        },
      ],
    },
    finalCta: {
      titleLines: [
        "まずはLINEで、",
        "Rick Owensの価値をご相談ください。",
      ],
      body:
        "レザー、ブーツ、ジオバスケット、ラモーンズ、DRKSHDW、アーカイブ作品まで確認。\nEnclopediaが、造形と再流通価値を見て宅配買取へ丁寧につなげます。",
      primaryLabel: "LINEで事前査定する",
      primaryHref: "https://line.me/R/ti/p/@240yzqkh",
      secondaryLabel: "宅配買取を申し込む",
      secondaryHref:
        "https://www.enclopedia-official.com/kaitori/takuhai",
    },
  };

export default article;
